import React, { useState, useEffect } from "react";
import "./Subscription.css";
import SubscriptionService from "../../../services/SubscriptionService";
import LoadingScreen from "../../../components/LoadingScreen/LoadingScreen";
import OrderConfirmationModal from "./OrderConfirmationModal";
import SideBar from "../../../components/Sidebar";
import Swal from "sweetalert2";

const Subscription = () => {
  const [loading, setLoading] = useState(true);
  const [subscriptionLoading, setSubscriptionLoading] = useState(false);
  const [commercialData, setCommercialData] = useState({});
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);

  useEffect(() => {
    fetchCommercialHandler();
  }, []);

  const fetchCommercialHandler = async () => {
    try {
      const result = await SubscriptionService.fetchCommercial("PREMIUM");
      if (result.success) {
        const responseData = result.data;
        if (responseData.status === "SUCCESS") {
          setCommercialData(responseData.data || {});
        } else {
          //    showError("Error", responseData.message);
        }
      } else {
        //  showError("Request Failed", result.message);
      }
    } catch (error) {
      //  showError("Error", "Failed to fetch subscription details");
    } finally {
      setLoading(false);
    }
  };

  const subscriptionHandler = async () => {
    setSubscriptionLoading(true);
    try {
      const result = await SubscriptionService.subscription("PREMIUM");
      if (result.success) {
        const responseData = result.data;
        if (responseData.status === "SUCCESS") {
          localStorage.setItem("premium_subscription_status", "true");

          Swal.fire(
            "Success!",
            responseData.message || "Subscription activated successfully!",
            "success",
          );

          setShowConfirmationModal(false);
          fetchCommercialHandler();
        } else {
          if (responseData.message === "You have already subscribed.") {
            localStorage.setItem("premium_subscription_status", "true");
          }
          Swal.fire("Oops!", responseData.message, "error");
        }
      } else {
        Swal.fire("Oops!", result.message || "Request Failed", "error");
      }
    } catch (error) {
      Swal.fire("Oops!", "Subscription failed. Please try again.", "error");
    } finally {
      setSubscriptionLoading(false);
    }
  };

  if (loading) {
    return <LoadingScreen />;
  }

  return (
    <div className="container-fluid mt-3">
      <div className="row">
        <SideBar />
        <div className="col-md-9 mb-3">
          <div className="card shadow-sm subscription-main-card">
            <div className="card-body">
              <div className="compact-subscription-container">
                {/* Header with Price Tag */}
                <div className="subscription-header-compact">
                  <div className="header-left">
                    <h1 className="subscription-title-compact">
                      Activate Premium Services
                    </h1>
                    <p className="subscription-tagline">
                      One-time payment • Lifetime access • Multiple income
                      streams
                    </p>
                  </div>
                  <div className="header-right">
                    <div className="price-badge">
                      <div className="price-amount">
                        ₹{commercialData.charges || "399"}
                      </div>
                      <div className="price-label">One Time</div>
                    </div>
                  </div>
                </div>

                {/* Compact Content Grid - Fixed overlapping issue */}
                <div className="compact-content-grid">
                  {/* Left Column: Features */}
                  <div className="features-column">
                    <div className="features-section">
                      <h3 className="section-title">
                        <span className="free-badge">FREE</span> Services
                        Included
                      </h3>
                      <ul className="compact-features-list free-features">
                        <li>
                          <span className="feature-icon">✅</span>
                          <span>Mobile Recharge</span>
                        </li>
                        <li>
                          <span className="feature-icon">✅</span>
                          <span>DTH Recharge</span>
                        </li>
                        <li>
                          <span className="feature-icon">✅</span>
                          <span>Utility Bills</span>
                        </li>
                        <li>
                          <span className="feature-icon">✅</span>
                          <span>NSDL PAN Agent</span>
                        </li>
                        <li>
                          <span className="feature-icon">💰</span>
                          <span>Up to 4% instant commission</span>
                        </li>
                      </ul>
                    </div>

                    <div className="features-section">
                      <h3 className="section-title">
                        <span className="premium-badge">PREMIUM</span> Unlock
                        These Services
                      </h3>
                      <ul className="compact-features-list premium-features">
                        <li>
                          <span className="feature-icon">🔓</span>
                          <span>Money Transfer Services</span>
                        </li>
                        <li>
                          <span className="feature-icon">🔓</span>
                          <span>UTI PAN Agent</span>
                        </li>
                        <li>
                          <span className="feature-icon">🔓</span>
                          <span>Insurance POSP (Health & Vehicle)</span>
                        </li>
                        <li>
                          <span className="feature-icon">🔓</span>
                          <span>
                            Sell & Earn: Demat, Bank Account, Credit Cards
                          </span>
                        </li>
                      </ul>
                    </div>
                  </div>

                  {/* Right Column: Benefits & CTA - Fixed positioning */}
                  <div className="cta-column">
                    <div className="benefits-card">
                      <h4 className="benefits-title">Why Go Premium?</h4>
                      <ul className="benefits-list">
                        <li>
                          <span className="benefit-icon">💳</span>
                          <span>One-time payment, no renewal fees</span>
                        </li>
                        <li>
                          <span className="benefit-icon">🚀</span>
                          <span>Start multiple income streams</span>
                        </li>
                        <li>
                          <span className="benefit-icon">🛡️</span>
                          <span>24/7 Dedicated support</span>
                        </li>
                        <li>
                          <span className="benefit-icon">📈</span>
                          <span>Higher earning potential</span>
                        </li>
                        <li>
                          <span className="benefit-icon">✨</span>
                          <span>All future features included</span>
                        </li>
                      </ul>
                    </div>

                    {/* Fixed CTA Section - Added clear separation */}
                    <div className="fixed-cta-section">
                      <div className="cta-summary">
                        <div className="summary-item">
                          <span>One-time payment</span>
                          <span className="summary-value">
                            ₹{commercialData.charges || "399"}
                          </span>
                        </div>
                        <div className="summary-item">
                          <span>Access duration</span>
                          <span className="summary-value">Lifetime</span>
                        </div>
                        <div className="summary-item total">
                          <span>Total Amount</span>
                          <span className="total-value">
                            ₹{commercialData.charges || "399"}
                          </span>
                        </div>
                      </div>

                      <button
                        className="subscribe-button-compact"
                        onClick={() => setShowConfirmationModal(true)}
                        disabled={subscriptionLoading}
                      >
                        {subscriptionLoading ? (
                          <>
                            <span className="spinner-small"></span>
                            Processing...
                          </>
                        ) : (
                          `Subscribe Now - ₹${commercialData.charges || "399"}`
                        )}
                      </button>

                      <p className="cta-note">
                        ✅ Recharge & bill payments remain free forever
                      </p>
                    </div>
                  </div>
                </div>

                {/* Comparison Table Section - Added below main content */}
                <div className="comparison-section">
                  <h3 className="comparison-title">
                    Comparison: Free vs Premium
                  </h3>
                  <div className="comparison-table-container">
                    <table className="comparison-table">
                      <thead>
                        <tr>
                          <th>Service</th>
                          <th className="free-col">Free Plan</th>
                          <th className="premium-col">Premium Plan</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>
                            <span className="service-icon">📱</span>
                            Mobile Recharge
                          </td>
                          <td className="free-col">
                            <span className="available">✅ Included</span>
                          </td>
                          <td className="premium-col">
                            <span className="available">✅ Included</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="service-icon">📺</span>
                            DTH Recharge
                          </td>
                          <td className="free-col">
                            <span className="available">✅ Included</span>
                          </td>
                          <td className="premium-col">
                            <span className="available">✅ Included</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="service-icon">💡</span>
                            Utility Bills
                          </td>
                          <td className="free-col">
                            <span className="available">✅ Included</span>
                          </td>
                          <td className="premium-col">
                            <span className="available">✅ Included</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="service-icon">🆔</span>
                            NSDL PAN Service (*)
                          </td>
                          <td className="free-col">
                            <span className="available">✅ Included</span>
                          </td>
                          <td className="premium-col">
                            <span className="available">✅ Included</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="service-icon">💸</span>
                            Money Transfer
                          </td>
                          <td className="free-col">
                            <span className="unavailable">
                              ❌ Not Available
                            </span>
                          </td>
                          <td className="premium-col">
                            <span className="available">✅ Available</span>
                          </td>
                        </tr>
                        {/* <tr>
                          <td>
                            <span className="service-icon">🆔</span>
                            NSDL PAN Service
                          </td>
                          <td className="free-col">
                            <span className="unavailable">
                              ❌ Not Available
                            </span>
                          </td>
                          <td className="premium-col">
                            <span className="available">✅ Available</span>
                          </td>
                        </tr> */}
                        <tr>
                          <td>
                            <span className="service-icon">🆔</span>
                            UTI PAN Service
                          </td>
                          <td className="free-col">
                            <span className="unavailable">
                              ❌ Not Available
                            </span>
                          </td>
                          <td className="premium-col">
                            <span className="available">✅ Available</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="service-icon">🏥</span>
                            Insurance Services
                          </td>
                          <td className="free-col">
                            <span className="unavailable">
                              ❌ Not Available
                            </span>
                          </td>
                          <td className="premium-col">
                            <span className="available">✅ Available</span>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <span className="service-icon">🏦</span>
                            Sell & Earn: Demat, Bank Account, Credit Cards
                          </td>
                          <td className="free-col">
                            <span className="unavailable">
                              ❌ Not Available
                            </span>
                          </td>
                          <td className="premium-col">
                            <span className="available">✅ Available</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* Order Confirmation Modal */}
              {showConfirmationModal && (
                <OrderConfirmationModal
                  charges={commercialData.charges || "399"}
                  onConfirm={subscriptionHandler}
                  onCancel={() => setShowConfirmationModal(false)}
                  loading={subscriptionLoading}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
